import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

const InformationSharing: React.FC = () => {
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        8. Compartilhamento e Tratamento de Informações Pessoais
      </Typography>

      <Typography paragraph>
        A INNOVA PLANO DE SAÚDE não disponibilizará Dados Pessoais coletados em seus sites para corretores de lista de e-mail sem seu expresso consentimento.
      </Typography>

      <Typography paragraph>
        A INNOVA PLANO DE SAÚDE poderá divulgar os Dados Pessoais coletados a terceiros, nas seguintes situações e nos limites exigidos e autorizados pela Lei:
      </Typography>

      <List>
        <ListItem>
          <ListItemText primary="I. Com os seus clientes e parceiros quando necessário e/ou apropriado à prestação de serviços relacionados;" />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary="II. Com as empresas e indivíduos contratados para a execução de determinadas atividades e serviços em nome da INNOVA PLANO DE SAÚDE;" />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary="III. Com empresas do grupo;" />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary="IV. Com fornecedores e parceiros para consecução dos serviços contratados com a INNOVA PLANO DE SAÚDE (como tecnologia da informação, contabilidade, entre outros);" />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary="V. Para propósitos administrativos como: pesquisa, planejamento, desenvolvimento de serviços, segurança e gerenciamento de risco." />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary="VI. Quando necessário em decorrência de obrigação legal, determinação de autoridade competente, ou decisão judicial." />
        </ListItem>
      </List>
    </div>
  );
};

export default InformationSharing;
